<template>
  <div class="login_main">
    <div class="login-container" id="login-container">
      <el-row class='logo_login' v-if="conf.mainImg">
        <img :src="conf.mainImg" alt="">
      </el-row>
      <el-row :span="24" class="welcome">账号登录</el-row>

      <el-form>
        <el-row>
          <el-col :span="24">
            <div class="inputContanier">
              <span><img src="../../static/img/username.png" alt="" style='display:block;width: 20px;'></span>
              <el-input id="username" v-model="username" placeholder="请输入账号" name="username"
                        prefix-icon="../../static/img/username.png" @blur="blur()" @focus="focus()">
              </el-input>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="inputContanier">
              <span><img src="../../static/img/password.png" alt="" style='display:block;width: 20px;'></span>
              <el-input id="password" v-model="password" type="password" @keyup.native.13='login_check()'
                        placeholder="请输入密码" @blur="blur()" @focus="focus()">
              </el-input>
            </div>
          </el-col>
        </el-row>

        <el-row v-if="conf.isValid">
          <el-col :span="24">
            <div class="inputContanier" v-show="code_display">
              <span><img src="../../static/img/code.png" alt="" style='display:block;width: 20px;'></span>
              <el-input id="code" ref="code" v-model="code" type="text" @keyup.native.13='login_check()'
                        placeholder="验证码">
                <template slot="append">
                  <img :src="code_img" alt="" @click='reloadcode' class="code_img">
                </template>
              </el-input>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-button id="login" @click="login_check" :disabled="isDisable" style="width:100%" type="primary">登录
            </el-button>
            <p class="footer-tip" v-if="conf.notice">{{ conf.notice }}</p>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="version" v-if="isVersion">
      v{{ version }}
    </div>
  </div>
</template>

<script>
import config from '@/../package.json'

export default {
  data () {
    return {
      conf: {},
      code_img: '',
      username: '',
      password: '',
      code: '',
      code_display: false,
      redirectURI: '',
      url: '',
      isDisable: false, // 提交按钮
      isVersion: true,
      version: ''
    }
  },
  mounted () {
    this.version = config.version
    this.config()
  },
  methods: {
    // 配置文件
    config () {
      this.$conf().then(({ data }) => {
        this.conf = data
        // 设置标题
        document.title = data.title
      })
    },
    isPhone () {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        return true
      }
      return false
    },
    blur () {
      if (this.isPhone()) {
        this.isVersion = true
      }
    },
    focus () {
      if (this.isPhone()) {
        this.isVersion = false
      }
    },
    // 失去焦点的时候触发input验证
    validate (event) {
      // 直接返回true，防止前端拦截密码和用户名
      return true
      // 获取值
      // let uPattern = /^[\u4e00-\u9fa5\w.]{3,20}$/
      // let pPattern = /^[\da-z]{6,10}$/i
      // // 用户名验证
      // if (!uPattern.test(this.username)) {
      //   // 用户名以中文，数字，字母，下划线，点号，组成，且长度在3-12之间
      //   this.error('请输入正确的用户名')
      // } else if (!pPattern.test(this.password)) {
      //   // 密码只能由数字和字母组成，长度为6-10位
      //   this.error('请输入正确的密码')
      // } else {
      //   return true
      // }
      // return false
    },
    // 验证码点击刷新
    reloadcode () {
      this.$axios({
        method: 'get',
        url: this.url + '/api/oauth/v1/verifyCode',
        params: {}
      }).then(res => {
        // console.log(res.data)
        this.code_img = res.data
      }).catch(err => {
        // console.log(err.data)
        this.code_img = err.data
      })
    },
    error (message) {
      this.$message({
        message: message,
        type: 'error'
      })
    },
    // 登录验证
    login_check () {
      // 处理按钮多次点击重复提交数据
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false
      }, 1000)
      if (!this.validate()) {
        return
      }
      // eslint-disable-next-line no-undef
      let encryptor = new JSEncrypt() // 新建JSEncrypt对象
      let publicKey = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCrdpdYMaIJjCT9/2aeyr442SR930wuykmpQWh+8p+DbZ/BzYMYOMFjzinf8bPYgMjRTHM/LiJfK1FP+Id1FKlpeUYansdAz7tpl4FzqALnhGxaAw2CqPMVs8brep142LOOyVnrvUz3XrZ+DrfflWpixwV4825HMhGUDfnNL6iS6wIDAQAB` // 把之前生成的贴进来，实际开发过程中，可以是后台传过来的
      encryptor.setPublicKey(publicKey) // 设置公钥

      var s = Math.random().toString(36).substr(2).toString() + '-' + this.username + '-' + this.password + '-' + (new Date().getTime() * 16 - 2345).toString() + '-' + (new Date().getTime() * 3).toString()
      let rsaEncrypt = encryptor.encrypt(s) // 对需要加密的数据进行加密

      var url = location.search
      if (url.indexOf('redirectURI') != -1) {
        var redirectURI = url.substr(13)
        this.redirectURI = redirectURI
      }
      this.$axios({
        method: 'post',
        url: this.url + '/api/oauth/v1/login',
        data: {
          account: rsaEncrypt,
          passWord: Math.random().toString(36).substr(2).toString(), // '123',
          verfyCode: this.code,
          redirectURI: this.redirectURI
        }
      }).then(res => {
        this.$message({
          message: '登录成功',
          type: 'success'
        })
        window.location.href = res.data.redirectURL
      }).catch(err => {
        this.error(err.response.data.msg || '未知错误')
        // 显示验证码
        if (err.response.headers.verfycode == 1) {
          this.$axios({
            method: 'get',
            url: this.url + '/api/oauth/v1/verifyCode',
            params: {}
          }).then(res => {
            this.code_display = true
            this.code_img = res.data
          }).catch(err => {
            this.error(err.response.data.msg || '网络异常')
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/login.vue